/**------------- Used Cars constants -------------**/

/*  General  */
export const USED_CARS_CONTAINER_CLASS_NAME =
	"used-cars-container";

/*  Title  */
export const USED_CARS_TITLE =
	"Il nostro store di auto usate.";

/*  Section's Animation  */
export const USED_CARS_ANIMATION_SCROLL_THRESHOLD = 0.55;

/*  Fallback  */
export const USED_CARS_UNAVAILABLE_CONTAINER_CLASS_NAME =
	"unavailable-used-cars-container";
export const USED_CARS_UNAVAILABLE_DESCRIPTION =
	"Auto momentaneamente esaurite. Stiamo preparando nuovi arrivi!";
export const USED_CARS_UNAVAILABLE_IMAGE_DESCRIPTION_ALT =
	"unavailable-used-cars-image";

/*  Data  */
export const USED_CARS_OVERVIEW_API_KEY =
	"used-cars-overview";

/*  Links  */
export const NO_USED_CAR_AVAILABLE_IMAGE_LINK =
	"/images/no-used-car-available.avif";

/**------------- Shared Used Cars constants -------------**/

/*  Price  */
export const PRICE_LOCALES = "it-IT";
export const PRICE_STYLE = "currency";
export const PRICE_CURRENCY = "EUR";

/*  Data  */
export const DATA_STALE_TIME = 1000 * 60 * 5;

/*  Drawer  */
export const USED_CAR_DRAWER_WIDTH = "100%";
export const USED_CAR_DRAWER_OPEN_CLASS_NAME =
	"drawer-open";

/*  Internal URLs  */
export const USED_CAR_DRAWER_URL = "auto-usate/";
